import React from 'react';

/** Stand-in thumbnail for a source from the user's own uploaded file (no page image): a document icon + type. */
export default function FileTile({ name, className = '' }) {
  const ext = (String(name || '').split('.').pop() || 'file').slice(0, 4).toUpperCase();
  return (
    <span className={`cv-file-tile ${className}`} aria-hidden="true">
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" /><path d="M8 13h8M8 17h5" />
      </svg>
      <span className="cv-file-tile__ext">{ext}</span>
      <span className="cv-file-tile__tag">Your file</span>
    </span>
  );
}
